import React from 'react';
import Tooltip from './Tooltip';
import Icon from './Icon';
import { cn } from '@/app/lib/utils';

export const InternalOnlyTooltip = ({
  className,
  side = 'left',
}: {
  className?: string;
  side?: 'top' | 'right' | 'bottom' | 'left';
}) => {
  return (
    <Tooltip
      label="Internal only"
      side={side}
      align="center"
      sideOffset={8}
      className={cn(
        'bg-neutral-900 text-white border-neutral-900 px-3 py-1.5 rounded-lg text-xs font-medium',
        className
      )}
      arrowClassName="fill-neutral-900"
    >
      <div className="inline-flex items-center justify-center rounded-full">
        <Icon
          name="information-line"
          className="text-away-base w-5 h-5"
          aria-label="Internal only info"
        />
      </div>
    </Tooltip>
  );
};

export default InternalOnlyTooltip;
